import styled from 'styled-components';
import { H1 } from 'toolkit/components';

interface HeaderProps {
  header: string;
}

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 33px;
  margin-bottom: 22px;
`;

const HeaderContentWrapper = styled.header`
  width: 100%;
  max-width: 1920px;
  padding: 0 20px;
  margin: 0 auto;
  clear: both;
  text-align: left;
`;

export default function Header({ header }: HeaderProps) {
  return (
    <HeaderContainer>
      <HeaderContentWrapper>
        <H1>{header}</H1>
      </HeaderContentWrapper>
    </HeaderContainer>
  );
}
